import styled from 'styled-components';
import { ButtonSecondary, cssSpacing } from '@spotify-internal/encore-web';
import {
  StyledIconExclamationActive,
  TypeWithLink,
  TypeWithMargin,
} from '@components/shared/styles';
import { formBodyHeight } from './constants';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: ${formBodyHeight};
`;

const StyledButtonSecondary = styled(ButtonSecondary)`
  cursor: pointer;
  margin-top: ${cssSpacing('base', '24px')};
`;

interface ErrorStateProps {
  title: string;
  text: string;
  textHasLink: boolean;
  // When provided, renders a single CTA button below the message (e.g.
  // "Back" to let the user fix bad input, or a retry for transient errors —
  // whatever action makes sense for the caller's error).
  onAction?: () => void;
  actionLabel?: string;
}

export const ErrorState = ({
  title,
  text,
  textHasLink = false,
  onAction,
  actionLabel,
}: ErrorStateProps) => {
  return (
    <Content>
      <StyledIconExclamationActive
        iconSize={32}
        data-cy="error-state"
        data-testid="exclamation-active-icon"
      />
      <TypeWithMargin
        variant="celloCanon"
        semanticColor="textBase"
        marginBottom={cssSpacing('tighter-2', '16px')}
        marginTop={cssSpacing('tighter-2', '16px')}
      >
        {title}
      </TypeWithMargin>
      {textHasLink ? (
        <TypeWithLink
          variant="viola"
          semanticColor="textBase"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      ) : (
        <TypeWithMargin variant="viola" semanticColor="textBase">
          {text}
        </TypeWithMargin>
      )}
      {onAction && (
        <StyledButtonSecondary
          buttonSize="sm"
          type="button"
          data-cy="error-action"
          onClick={onAction}
        >
          {actionLabel}
        </StyledButtonSecondary>
      )}
    </Content>
  );
};
